/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Back_ButtonInputs */



/**
* | output |
* | --- |
* | "Back" |
*
* @param {New_Project_Back_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_back_button = /** @type {((inputs?: New_Project_Back_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Back_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dos")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indietro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назад")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atrás")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("后退")
	if (locale === "ja") return /** @type {LocalizedString} */ ("戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पीछे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar")
	return /** @type {LocalizedString} */ ("Back")
});